import { Theme } from "contexts/ThemeProvider";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "contexts/AppProvider";
import { Start } from "pages/Start";
import { Personal } from "pages/Personal";
import { PatientForm } from "pages/Form";
import { ThankYou } from "pages/ThankYou";
import { Layout } from "components/Layout";
import "./App.css";
import LangProvider from "contexts/LangProvider";
// src/index.js

const RequireSlot = ({ children }: { children: JSX.Element }) => {
  const { activeTimeslot } = useApp();
  if (!activeTimeslot) return <Navigate to="/" replace />;
  return children;
};

function App() {
  const location = useLocation();
  const isPersonalFlow =
    location.pathname === "/personal" || new URLSearchParams(location.search).get("personal") === "1";

  return (
    <div className={`App${isPersonalFlow ? " App--personal" : ""}`}>
      <LangProvider>
        <AppProvider>
          <Theme>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<Start />} />
                <Route path="personal" element={<Personal />} />
                <Route
                  path="form"
                  element={
                    <RequireSlot>
                      <PatientForm />
                    </RequireSlot>
                  }
                />
                <Route path="thank-you" element={<ThankYou />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Route>
            </Routes>
          </Theme>
        </AppProvider>
      </LangProvider>
    </div>
  );
}

export default App;
